import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ReportService } from '../../services/reports.service';
import { FolderService } from '../../services/folder.service';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-new-folder',
  templateUrl: './new-folder.component.html',
  styleUrls: ['./new-folder.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewFolderComponent implements OnInit,AfterViewInit {
  @ViewChild('folderNameInput') folderNameInput!: ElementRef;

  dialogData: any;
  newFolderForm: FormGroup;
  selectedFolder: any = '';
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<NewFolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private reportService: ReportService,
    public utilityService: UtilityService,
    private folderService: FolderService,
    private toast: HotToastService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.dialogData = this.data?.data;
    if(this.dialogData?.action === 'edit'){
       this.selectedFolder = this.dialogData?.folderDetails?.folder_name;
    }
    this.newFolderForm = new FormGroup({
      newFolder: new FormControl(this.selectedFolder ? this.selectedFolder : '',Validators.required)
   });
  }
  submit(): any{
    this.newFolderForm.markAllAsTouched();
    if(this.newFolderForm.valid){
      this.isLoading = true; 
        const payload: any = {
          'folder_name' :this.newFolderForm?.value?.newFolder
        };
        if(this.dialogData?.action === 'new'){
        this.reportService.createFolder(payload).subscribe((res)=>{
          this.isLoading = false;
          this.dialogRef.close({value:this.newFolderForm?.value,action:this.dialogData?.action,response:res});
          this.folderService.notifyFolderUpdated({isUpdated: true});
        },
        ()=>{
          this.isLoading = false;
        }
      );
      }
        else {
          this.reportService.updateFolder(payload,this.dialogData?.folderDetails?.folder_uid).subscribe((res)=>{
            this.isLoading = false;
            this.dialogRef.close({value:this.newFolderForm?.value,action:this.dialogData?.action,response:res});
            this.toast.success(res?.message);
            this.folderService.notifyFolderUpdated({isUpdated: true});
          },
        ()=>{
          this.isLoading = false;
        });
        }
      }
    }
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.folderNameInput) {
        this.folderNameInput.nativeElement.focus();
      }
    }, 100);
    this.cdr.detectChanges();
  }
  }


